function search() {
    /* OPEN SEARCH */
    var navbutton = document.getElementById("button__navigation");
    var navigation = document.getElementById("navigation");
    var searchButton = document.getElementById("button__search");
    var searchArea = document.getElementById("search-menu");

    searchButton.addEventListener('click', () => {
        searchArea.classList.toggle("search-menu--visible");
        searchButton.classList.toggle("button__search--open");

        if (searchButton.classList.contains("button__search--open")) {
            navigation.classList.remove("navigation--visible");
            navbutton.classList.remove("navigation--visible");
            navbutton.innerHTML = "MENU";
            searchArea.querySelector("input").setAttribute('tabindex', '0');
            searchArea.querySelector("input").focus();
            searchButton.setAttribute('aria-expanded', 'true');
        } else {
            searchArea.querySelector("input").setAttribute('tabindex', '-1');
            searchArea.querySelector("input").blur();
            searchButton.setAttribute('aria-expanded', 'false');
        }
    })

    let searchInput = document.getElementById("search");
    let searchLinks = document.querySelector(".search-result__links");
    let searchEmployee = document.querySelector(".search-result__employees");
    let seachValidation = document.querySelector(".search-validation");

    if (!searchInput)
        return

    searchInput.addEventListener('input', () => {
        let searchValue = searchInput.value;
        let fetchRes = fetch(`/umbraco/api/search/search?term=${searchValue}`);
        if (searchValue.length >= 3) {
            fetchRes.then(res => res.json()).then(d => {
                searchLinks.innerHTML = "";
                searchEmployee.innerHTML = "";
                seachValidation.innerHTML = "";

                if (d.results.length == 0) {
                    seachValidation.innerHTML = "Fandt du ikke, hvad du søgte - prøv igen";
                } else {

                    seachValidation.innerHTML = "";

                    d.results.forEach(result => {
                        if (result.link) {
                            searchLinks.innerHTML +=
                                `<a class="search-result__link button__arrow" href="${result.link}">${result.title}</a>`
                        }
                        else {
                            searchEmployee.innerHTML += `
                        <div class="search-result__employee">
                            <div class="search-result__employee-image">
                                <img src="${result.image}" alt="${result.name}">
                            </div>
                            <div class="search-result__employee-information">
                                <div class="search-result__employee-top">
                                    <p><strong>${result.name}</strong></p>
                                    <p>${result.title}</p>
                                </div>
                                <div>
                                    <p><strong>${result.department}</strong></p>
                                    <p><a href="tel:${result.telephone}">${result.telephone}</a></p>
                                    <p><a href="mailto:${result.email}">${result.email}</a></p>
                                </div>
                            </div>
                        </div>
                        `
                        }
                    });
                }
            })
        } else if (searchValue.length >= 1) {
            seachValidation.innerHTML = "Skriv mindst 3 tegn";
            searchEmployee.innerHTML = "";
        } else {
            seachValidation.innerHTML = "";
            searchLinks.innerHTML = "";
            searchEmployee.innerHTML = "";
        }
    })
}

function searchBookingPhysical() {
    let searchInput = document.getElementById("booking__search__field__p");
    let searchResultPhysical = document.querySelector(".booking__result__physical");
    let noResultsLabel = document.querySelector(".booking__result__physical__noresults");

    if (!searchInput)
        return

    searchInput.addEventListener('input', (e) => {
        let searchValue = searchInput.value;
        let searchType = 'Student';
        if (searchValue.length >= 3) {
            let fetchRes = fetch(`/umbraco/api/search/searchBooking?term=${searchValue}&resultType=${searchType}`);
            fetchRes.then(res => res.json()).then(d => {

                // check for Å-Aa, Ø-Oe
                var altSearchValue = respell(searchValue);
                if (altSearchValue != searchValue) {
                    // found alternative spelling
                    let fetchResAlt = fetch(`/umbraco/api/search/searchBooking?term=${altSearchValue}&resultType=${searchType}`);
                    fetchResAlt.then(res => res.json()).then(dAlt => {
                        d.results.push(...dAlt.results);
                        writeResults(d.results, searchResultPhysical, noResultsLabel);
                    });

                } else {
                    // no alternative spelling
                    writeResults(d.results, searchResultPhysical, noResultsLabel);
                }

            })
        } else {
            searchResultPhysical.innerHTML = "";
        }
    })
}

function searchBookingOnline() {
    let searchInput = document.getElementById("booking__search__field__o");
    let searchResultOnline = document.querySelector(".booking__result__online");
    let noResultsLabel = document.querySelector(".booking__result__online__noresults");


    if (!searchInput)
        return

    searchInput.addEventListener('input', (e) => {
        let searchValue = searchInput.value;

        let searchType = 'NonStudent';
        if (searchValue.length === 0 || searchValue.length >= 3) {
            let fetchRes = fetch(`/umbraco/api/search/searchBooking?term=${searchValue}&resultType=${searchType}`);
            fetchRes.then(res => res.json()).then(d => {

                // check for Å-Aa, Ø-Oe
                var altSearchValue = respell(searchValue);
                if (altSearchValue != searchValue) {
                    // found alternative spelling
                    let fetchResAlt = fetch(`/umbraco/api/search/searchBooking?term=${altSearchValue}&resultType=${searchType}`);
                    fetchResAlt.then(res => res.json()).then(dAlt => {
                        d.results.push(...dAlt.results);
                        writeResults(d.results, searchResultOnline, noResultsLabel);
                    });

                } else {
                    // no alternative spelling
                    writeResults(d.results, searchResultOnline, noResultsLabel);
                }
            })
        } else {
            searchResultOnline.innerHTML = "";
        }
    })
}

function initialSearchBookingOnline() {
    let searchInput = document.getElementById("booking__search__field__o");
    let searchResultOnline = document.querySelector(".booking__result__online");

    if (!searchInput)
        return

    let searchValue = searchInput.value;
    let searchType = 'NonStudent';
    let fetchRes = fetch(`/umbraco/api/search/searchBooking?term=${searchValue}&resultType=${searchType}`);
    fetchRes.then(res => res.json()).then(d => {
        searchResultOnline.innerHTML = "";

        d.results.forEach(result => {
            if (result.link) {
                searchResultOnline.innerHTML +=
                    `<button class="booking__listbutton" value="${result.link}">${result.title}</button>`
            }
        });
    })
}

function respell(searchValue) {

    searchValue = searchValue.toLowerCase();
    // flip Å
    if (searchValue.includes("å")) {
        searchValue = searchValue.split("å").join("aa");
    } else if (searchValue.includes("aa")) {
        searchValue = searchValue.split("aa").join("å");
    }
    // flip Ø
    if (searchValue.includes("ø")) {
        searchValue = searchValue.split("ø").join("oe");
    } else if (searchValue.includes("oe")) {
        searchValue = searchValue.split("oe").join("ø");
    }

    // flip Æ
    if (searchValue.includes("æ")) {
        searchValue = searchValue.split("ø").join("ae");
    } else if (searchValue.includes("ae")) {
        searchValue = searchValue.split("ae").join("æ");
    }

    return searchValue
}

function writeResults(results, parentElement, noResultsElement) {

    // clear
    parentElement.innerHTML = "";

    // write results
    results.forEach(result => {
        if (result.link) {
            parentElement.innerHTML +=
                `<button class="booking__listbutton" value="${result.link}">${result.title}</button>`
        }
    });

    // no results
    if (results.length == 0) {
        noResultsElement.style.display = 'block';
    } else {
        noResultsElement.style.display = 'none';
    }
}